import { authRequest } from './client';
import { type ListRefundsParams, type ListRefundsResponse } from './types';

// ─── backoffice-api refunds client ─────────────────────────────────────────
//
// Thin fetch wrapper around backoffice-api's `/v1/refunds` endpoint — a
// global (all-merchant) read-only refunds list. Requires INVOICES_VIEWER (or
// SUPERADMIN). No configurable sort — the backend fixes it to
// `createdAt DESC, id DESC`.

export function listRefunds(params: ListRefundsParams = {}): Promise<ListRefundsResponse> {
  const query = new URLSearchParams();
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.status !== undefined) query.set('status', params.status);
  if (params.initiator !== undefined) query.set('initiator', params.initiator);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  const qs = query.toString();
  return authRequest<ListRefundsResponse>(`/refunds${qs ? `?${qs}` : ''}`);
}
